import jQuery from 'jquery';
import app from './Vue/app';
import useWhenActivated from '@composables/useWhenActivated';

async function initPage() {
    await useWhenActivated;
	const ga = document.createElement('script')
	ga.async = true
	ga.src = 'https://www.googletagmanager.com/gtag/js?id=G-LTKL4G4RH9';
	document.head.appendChild(ga);
	window.gtag('js', new Date());
	window.gtag('config', 'G-LTKL4G4RH9');
    app.mount('main');
};

// if ('serviceWorker' in navigator && window.location.hostname == 'www.domain.com') {
//     window.addEventListener('load', ()=>{
//         navigator.serviceWorker.register('/sw.js')
//         .then(function(reg){

//         }).catch(function(err) {

//         });
//     });
// }
dataLayer = window.dataLayer = window.dataLayer || [ ];
function gtag(){
    dataLayer.push(arguments);
}
window.dataLayer = dataLayer;

window.gtag = gtag;
window.jQuery = jQuery;
window.$ = jQuery;
initPage();
